
import react, { useEffect, useState } from 'react';

type ResizePredicate = () => boolean;

const useResizeHandler = (predicate: ResizePredicate, deps?: React.DependencyList) => {
    const [ width, setWidth ] = useState<number>(0);

    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        if (predicate()) {
            window.addEventListener('resize', handleResize);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, deps)

    return width;
};

export default useResizeHandler;